module.exports = __webpack_public_path__ + "img/minus_btn.9ebc6707.png";